import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import axios from 'axios';

export default function AutoLogin() {
  const navigate = useNavigate();
  const { token, dept } = useParams();

  useEffect(() => {
    if (!token || !dept) {
      toast.error("Invalid login link.");
      return;
    }

    const apiUrl = `https://${dept.toLowerCase()}.firehouse247.com/api/slfinalize`;

    (async () => {
      const body = {
        code: token
      }
      try {
        const res = await axios.post(apiUrl, body, { headers: { Accept: 'application/json' } });
        const data = res?.data;

        localStorage.setItem("department", dept);
        localStorage.setItem("token", token); // store original token
        localStorage.setItem("user", JSON.stringify(data?.user));
        localStorage.setItem("permission", JSON.stringify(data?.permission));
        localStorage.setItem("pages", JSON.stringify(data?.allowedPages));
        localStorage.setItem("pagesName", JSON.stringify(data?.PagesNames));
        localStorage.setItem("is_dn_deparment", JSON.stringify(data?.is_dn_deparment));

        toast.success("Login Successful");
        navigate("/firehouse/accept-shifts-mobile");
      } catch (error) {
        console.error(error);
        toast.error(error?.response?.data?.message || error.message);
      }
    })();
  }, [token, dept, navigate]);

  return (
    <div className="d-flex flex-column align-items-center justify-content-center" style={{ height: "100vh", width: "100%" }}>
      <img src="/images/blur-logo.png" style={{ height: 200, width: 250 }} alt="logo" />
      <span className="mt-4" style={{ color: "#555555" }}>Redirecting...</span>
    </div>
  );
}
